import styles from './index.less';
import { queryAccountInfo } from '@/pages/AccountInfo/service';
import { useModel } from '@umijs/max';
import { useEffect, useState } from 'react';
import { accountInfoType } from '@/pages/AccountInfo/interface';
import { formattedDate } from '@/utils/format';
import NoData from '@/components/NoData';

const AccountInfo = () => {
  const { wechatAccountInfo } = useModel('useGlobal', (model) => ({
    wechatAccountInfo: model.wechatAccountInfo,
  }));
  const [accountInfoList, setAccountInfoList] = useState<accountInfoType[]>([]);
  const handleAccountInfoList = () => {
    queryAccountInfo({ ownerId: wechatAccountInfo?.ownerId }).then((res) => {
      if (res?.code === 200) {
        setAccountInfoList(res?.data?.list || []);
      }
    });
  };
  const detailTypeMap: any = {
    1: '充值',
    2: '抵扣',
    3: '退款',
  };

  useEffect(() => {
    if (wechatAccountInfo?.ownerId) {
      handleAccountInfoList();
    }
  }, [wechatAccountInfo]);

  return (
    <div className={styles.container}>
      {accountInfoList?.length !== 0 ? (
        <>
          {accountInfoList.map((item) => (
            <div key={item.id}>
              <div className={styles.label}>交易编号：{item.id}</div>
              <div className={styles.content}>
                <div className={styles.payment}>
                  <p>
                    <span>￥</span> {item.amount}
                  </p>
                  <span
                    className={
                      item.detailType === 1
                        ? styles['text-blue']
                        : styles['text-orange']
                    }
                  >
                    {detailTypeMap[item?.detailType]}
                  </span>
                </div>
                <div className={styles['payment-time']}>
                  交易时间：
                  {formattedDate(item.creatorTime, 'YYYY-MM-DD HH:mm:ss')}
                </div>
              </div>
            </div>
          ))}
        </>
      ) : (
        <NoData />
      )}
    </div>
  );
};

export default AccountInfo;
